<template>
  <div>
    <CModal :show.sync="showModal" :backdrop="false" size="sm" ref="myModal">
      <div class="modal_body">
        <div
          :class="can_start ? 'modal_active' : 'modal_inactive'"
          @click="nextRoute(content, 0)"
        >
          <img
            v-if="can_start"
            src="@/assets/images/CH2/finish.png"
            alt=""
            class="icon_active icon_modal"
          />
          <p class="modal_text">Start</p>
        </div>
        <div
          :class="can_flip ? 'modal_active' : 'modal_inactive'"
          @click="nextRoute(content, 1)"
        >
          <img
            v-if="can_flip"
            src="@/assets/images/CH2/finish.png"
            alt=""
            class="icon_active icon_modal"
          />
          <img
            v-else
            src="@/assets/images/CH2/wrong.png"
            alt=""
            class="icon_inactive icon_modal"
          />
          <p class="modal_text">Vocabulary</p>
        </div>
        <div
          :class="can_assignment ? 'modal_active' : 'modal_inactive'"
          @click="nextRoute(content, 2)"
        >
          <img
            v-if="can_assignment"
            src="@/assets/images/CH2/finish.png"
            alt=""
            class="icon_active icon_modal"
          />
          <img
            v-else
            src="@/assets/images/CH2/wrong.png"
            alt=""
            class="icon_inactive icon_modal"
          />
          <p class="modal_text">Assignment</p>
        </div>
        <div
          :class="can_test ? 'modal_active' : 'modal_inactive'"
          @click="nextRoute(content, 3)"
        >
          <img
            v-if="can_test"
            src="@/assets/images/CH2/finish.png"
            alt=""
            class="icon_active icon_modal"
          />
          <img
            v-else
            src="@/assets/images/CH2/wrong.png"
            alt=""
            class="icon_inactive icon_modal"
          />
          <p class="modal_text">Test</p>
        </div>

        <div class="modal_active" @click="showResult()">
          <img
            src="@/assets/images/CH2/finish.png"
            alt=""
            class="icon_active icon_modal"
          />
          <p class="modal_text">Result</p>
        </div>
      </div>
    </CModal>
    <template v-if="loading">
      <div class="container vertical-center">
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <div
        style="
          height: 100%;
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        "
      >
        <div class="progress_image">
          <div class="fox_progress">
            <img
              src="@/assets/images/CH2/FOX_FILL.png"
              alt=""
              srcset=""
              class="img_progress"
              v-if="can_flip"
            />
            <img
              src="@/assets/images/CH2/FOX_FILL_whtie.png"
              alt=""
              srcset=""
              class="img_progress"
              v-else
            />
          </div>
          <div class="fox_progress">
            <img
              src="@/assets/images/CH2/FOX_FILL.png"
              alt=""
              srcset=""
              class="img_progress"
              v-if="can_assignment"
            />
            <img
              src="@/assets/images/CH2/FOX_FILL_whtie.png"
              alt=""
              srcset=""
              class="img_progress"
              v-else
            />
          </div>
          <div class="fox_progress">
            <img
              src="@/assets/images/CH2/FOX_FILL.png"
              alt=""
              srcset=""
              class="img_progress"
              v-if="can_test"
            />
            <img
              src="@/assets/images/CH2/FOX_FILL_whtie.png"
              alt=""
              srcset=""
              class="img_progress"
              v-else
            />
          </div>
        </div>
        <div class="body">
          <div
            class="swiper-button-prev swiper-button-color display-none"
            slot="button-prev"
          />
          <div class="body-swip">
            <swiper
              class="swiper"
              :options="swiperOption"
              @slideChange="onSlide"
              ref="mySwiper"
            >
              <swiper-slide v-for="(item, index) in content" :key="index">
                <div
                  class="swip_active"
                  :id="item.id"
                  @click="onSelected(item, index)"
                >
                  <div
                    v-if="menulock[index]?.lock == false"
                    style="position: relative; width: 100%; height: 100%"
                  >
                    <img
                      class="card icon"
                      :src="baseUrl + '' + item?.icon?.enable?.data"
                    />
                  </div>
                  <!-- lock overlay -->
                  <div
                    v-if="menulock[index]?.lock == true"
                    style="position: relative; width: 100%; height: auto"
                  >
                    <div
                      style="
                        width: 100%;
                        background-color: rgba(116, 185, 255, 0.7);
                        height: 100%;
                        position: absolute;
                        top: 0;
                        border-radius: 50px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        z-index: 99;
                        cursor: pointer;
                      "
                    >
                      <img
                        src="@/assets/images/CH2/lock.png"
                        style="cursor: pointer; pointer-events: none"
                        alt=""
                      />
                    </div>
                    <img
                      class="card icon"
                      :src="baseUrl + '' + item?.icon?.enable?.data"
                      :ref="'card-' + index"
                    />
                  </div>
                  <div class="detail_content">
                    <div class="textgray" style="text-align: center">
                      <h6 style="color: #89abe6">
                        {{ checkLanguage(item.title) }}
                      </h6>
                    </div>
                    <div class="textblack" style="text-align: center">
                      <h4 :class="checkLangClass()">
                        {{ checkLanguage(item.description) }}
                      </h4>
                    </div>
                    <div class="ContentProgressBar">
                      <CProgress
                        :showPercentage="true"
                        class="ProgressBar"
                        :value="menulock[index]?.progress"
                        :animated="false"
                        :show-value="true"
                        height="15px"
                      />
                    </div>
                  </div>
                </div>
              </swiper-slide>
            </swiper>
          </div>
          <div
            class="swiper-button-next swiper-button-color display-none"
            slot="button-next"
          />
        </div>
        <div
          style="
            position: absolute;
            bottom: 8%;
            left: 0;
            right: 0;
            margin: 0 auto;
          "
        >
          <Dothorizontal :items="10" :active="index_active" />
        </div>
      </div>
    </template>

    <!-- modal -->

    <modal class="container" name="my-first-modal">
      <div class="container" v-if="result_data">
        <div class="edit_modal">
          <h5>Result</h5>
          <div v-for="(item, index) in result_data.data" :key="index">
            <div class="space_text container">
              <div class="row">
                <div class="col-sm-4">
                  <h6 style="text-align: left">{{ item.name }}</h6>
                </div>
                <div class="col-sm-4">
                  <CProgress
                    :showPercentage="true"
                    class="progressbar_size"
                    :value="item?.progress"
                    :animated="false"
                    :show-value="true"
                    height="30px"
                  />
                </div>
                <div class="col-sm-4">
                  <h6 style="text-align: right">{{ item.score }}</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </modal>

    <!-- modal -->
  </div>
</template>

<script>
import {Swiper, SwiperSlide} from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import LoadingMDL from '../../../../components/loading/LoadingMDL.vue';
import Dothorizontal from '../../../../components/elements/Dothorizontal.vue';
import {mapGetters} from 'vuex';

export default {
  name: 'SwiperItem',
  components: {
    Swiper,
    SwiperSlide,
    LoadingMDL,
    Dothorizontal,
  },
  props: {
    items: Array,
    lang: String,
    subProgress: Array,
    allContent: Object,
    lessonActive: Number,
  },
  data() {
    return {
      can_start: true,
      can_flip: false,
      can_test: false,
      can_assignment: false,
      showModal: false,
      index_swiper_select: null,
      loading: true,
      baseUrl: process.env.VUE_APP_URL_SOUND,
      swiperOption: {
        effect: 'coverflow',
        slidesPerView: 3,
        initialSlide: 0,
        spaceBetween: 0,
        grabCursor: false,
        centeredSlides: true,
        loop: true,
        loopFillGroupWithBlank: false,
        breakpoints: {
          // when window width is >= 320px
          1024: {
            slidesPerView: 3,
            spaceBetween: -30,
            coverflowEffect: {
              rotate: 0,
              stretch: 0,
              depth: 20,
              modifier: 2,
              slideShadows: false,
            },
          },
          1366: {
            slidesPerView: 3,
            spaceBetween: -80,
            coverflowEffect: {
              rotate: 0,
              stretch: 0,
              depth: 20,
              modifier: 1,
              slideShadows: false,
            },
          },
          1530: {
            slidesPerView: 3,
            coverflowEffect: {
              rotate: 0,
              stretch: 0,
              depth: 25,
              modifier: 1,
              slideShadows: false,
            },
          },
        },
        coverflowEffect: {
          rotate: 0,
          stretch: 0,
          depth: 25,
          modifier: 5,
          slideShadows: false,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      showProgress: 0,
      activeRef: 0,
      content: [],
      menulock: [],
      checkPoints: [],
      index_active: 0,
      code: '',
      section: '',

      //showResult
      result_isShow: false,
      result_showModal: false,
      result_closeModal: false,
      result_data: null,

      //
      hasLoaded: false,
    };
  },
  created() {
    window._this = this;
    this.code = this.$store.getters['necessary/getLerningCourse']._id;
    this.section = this.$store.getters['necessary/getUserCourseSection'];
    // console.log(this.section);
  },
  computed: {
    ...mapGetters({
      getStatus: 'template/getStatusTest',
      v3LessonLockStatus: 'v3-data/v3LessonLockStatus',
    }),
  },
  watch: {
    index_swiper_select(val) {
      // console.log(val, 'index swiper');
    },
    v3LessonLockStatus: function (val) {
      if (val.type == 'chapter') {
        let body = {
          path: this.content[this.index_swiper_select].checkPoints[3].action,
          lock: val.isLock,
        };
        this.$emit('nextRoute', body);
      }
    },
  },
  mounted() {
    this.activeRef = this.$refs['mySwiper'];

    this.content = this.items.slice(0, 10);

    this.menulock = this.allContent.menuLock.slice(1, 11);

    this.checkPoints = this.allContent.checkPoints;
    this.checkProgress();
    this.swiperOption.initialSlide = this.lessonActive;
    this.loading = false;
  },
  beforeDestroy() {},
  methods: {
    showResult: function () {
      this.$modal.show('my-first-modal');

      this.result_data = this.subProgress[this.index_swiper_select];

      let store = [];
      for (let i = 0; i < this.result_data.topics.length; i++) {
        const element = this.result_data.topics[i];
        // console.log('swoper subprogress', element)
        if (element.type == 'topic' || element.type == 'Start') {
          element.name = 'Start';
          element.order = 1;
        }
        if (element.type == 'flipcard' || element.type == 'Vocabulary') {
          element.name = 'Vocabulary';
          element.order = 2;
        }
        if (element.type == 'assignment' || element.type == 'Assignment') {
          element.name = 'Assignment';
          element.order = 3;
        }
        if (element.type == 'test' || element.type == 'Test') {
          element.name = 'Test';
          element.order = 4;
        }
        store.push(element);
      } //loop

      this.result_data.data = store;
    },
    nextRoute: function (val, index) {
      var path = '';
      if (index === 0 && this.can_start) {
        path = val[this.index_swiper_select].checkPoints[index].action;
      } else if (index === 1 && this.can_flip) {
        path = val[this.index_swiper_select].checkPoints[index].action;
      } else if (index === 2 && this.can_assignment) {
        path = val[this.index_swiper_select].checkPoints[index].action;
      } else if (index === 3 && this.can_test) {
        //for test
        path = val[this.index_swiper_select].checkPoints[index].action;
        const allLesson = this.allContent.menuLock.slice(1, 11);
        const templateCode = allLesson[this.index_swiper_select].code;

        const payload = {
          courseId: this.$store.state.v3.v3EnrollData.data.courseinfo,
          section: this.$store.state.v3.v3EnrollData.data.section,
          codeItem: templateCode,
        };

        this.$store.dispatch('v3-data/v3LessonLockStatus', payload);

        this.showModal = false;
        return;
        // }
      }
      this.showModal = false;
      this.$emit('nextRoute', path);
    },
    onSelected: function (item, index) {
      // console.log(item, index);
      const swiper = this.$refs.mySwiper.$swiper;

      const realIndex = swiper.realIndex; // index ของ slide จริง (ไม่รวม clone)

      //filter only chapter
      const allContentChapter = this.allContent.menuLock.filter(
        (p) => p.type === 'chapter'
      );
      const lessonCodeFilter = allContentChapter[realIndex];
      this.$store.commit('v3/stampLessonCode', lessonCodeFilter.code);

      if (index === realIndex) {
        this.index_swiper_select = realIndex;

        if (this.menulock[realIndex]?.lock == false) {
          this.checkProgress(realIndex);
          this.$store.commit('necessary/setLessonActive', parseInt(realIndex));
          this.showModal = true;
          return;
        }

        this.showModal = false;
      }
      //new

      let card_active = document.getElementsByClassName('swiper-slide-active');
      // console.log(card_active);

      try {
        // Try first shake path
        const node =
          card_active[0]?.childNodes?.[0]?.childNodes?.[0]?.childNodes?.[0];
        if (node && node.classList) {
          node.classList.add('on_shake');
          setTimeout(() => {
            node.classList.remove('on_shake');
          }, 1000);
        } else {
          // Try fallback second shake path
          const node1 =
            card_active[0]?.childNodes?.[0]?.childNodes?.[1]?.childNodes?.[0];
          const node2 =
            card_active[0]?.childNodes?.[0]?.childNodes?.[1]?.childNodes?.[1];
          if (node1 && node2 && node1.classList && node2.classList) {
            node1.classList.add('on_shake');
            node2.classList.add('on_shake');
            setTimeout(() => {
              node1.classList.remove('on_shake');
              node2.classList.remove('on_shake');
            }, 1000);
          } else {
            console.warn('Shake targets not found');
          }
        }
      } catch (e) {
        console.error('Error during shake animation:', e);
      }
    },
    checkProgress: function (index) {
      // console.log(index);

      let lessonActive = this.$store.getters['necessary/getLessonActive'];
      let progress = [false, false, false];
      this.can_flip = progress[0];
      this.can_test = progress[1];
      this.can_assignment = progress[2];

      this.checkPoints.map((i, val) => {
        // const lesson = i._id.topic.split("-");
        const lesson = i.codeItem.split('-');
        if (
          parseInt(index != undefined ? index : lessonActive) + 1 ==
          lesson[1]
        ) {
          if (lesson[2] == 1) {
            // og = 2
            // this.can_flip = true;
            progress[0] = true;
          }
          if (lesson[2] == 2) {
            // og = 3
            // this.can_assignment = true;
            progress[2] = true;
          }
          if (lesson[2] == 3) {
            // og = 4
            // this.can_test = true;
            progress[1] = true;
          }
        }
      });
      this.can_flip = progress[0];
      this.can_test = progress[1];
      this.can_assignment = progress[2];
    },
    onSlide: function () {
      const swiper = this.$refs.mySwiper.$swiper;
      // console.log(swiper);

      this.showModal = false;
      if (!swiper) {
        this.showProgress = 0;
        return;
      }
      const index = swiper.realIndex ?? 0;
      this.activeRef = index;
      this.showProgress = index;
      this.index_active = index;

      this.checkProgress(index);
    },
    checkLanguage(val) {
      if (val) {
        try {
          for (let i = 0; i <= val.length; i++) {
            if (val[i].key != null) {
              if (val[i].key.toUpperCase() == this.lang) {
                return val[i].value;
              }
            }
          }
        } catch (err) {
          console.log('change language is error!!');
        }
      } else {
        console.log('change language is error!!');
      }
    },
    checkLangClass() {
      if (this.lang == 'CN') {
        return 'fontChinese description';
      } else {
        return 'description';
      }
    },
  },
};
</script>

<style scoped lang="scss">
* {
  font-family: 'Roboto';
}

@font-face {
  font-family: 'KaiTi';
  src: local('KaiTi'),
    url('../../../../assets/font/KaiTi.ttf') format('truetype');
}

.on_shake {
  // width: 10px !important;
  animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  perspective: 1000px;
  // transform: translate(1px, 1px) rotate(0deg);
}

.edit_modal {
  display: flex;
  flex-direction: column;
  text-align: center;
  width: 100%;
  margin-top: 3%;
}

.space_text {
  width: 100%;
  align-items: center;
  padding-top: 20px;
}

.progressbar_size {
  width: 100%;
}

::v-deep .vm--modal {
  width: 600px !important;
  border-radius: 10px;
}

@keyframes shake {
  10%,
  90% {
    transform: translate3d(-5px, 0, 0);
  }

  20%,
  80% {
    transform: translate3d(10px, 0, 0);
  }

  30%,
  50%,
  70% {
    transform: translate3d(-15px, 0, 0);
  }

  40%,
  60% {
    transform: translate3d(15px, 0, 0);
  }
}

::v-deep .swiper-slide .swiper-slide-active {
  width: 280px;
  transition-duration: 0ms;
  transform: translate3d(0px, 0px, 0px) rotateX(0deg) rotateY(0deg);
  z-index: 1;
  background-color: transparent;
}

.fox_progress {
  display: flex;
}

.progress_image {
  display: flex;
  justify-content: center;
}

.textblack {
  width: 100%;
}

::v-deep .overflow-auto {
  backdrop-filter: unset !important;
}

::v-deep .tooltip-inner {
  background-color: #89abe6;
}

::v-deep .bs-tooltip-auto[x-placement^='top'] .arrow::before,
.bs-tooltip-top .arrow::before {
  border-top-color: #89abe6 !important;
}

.fontChinese {
  font-family: 'KaiTi' !important;
  font-size: 30px;
}

.description {
  // background-color: red;
  color: #1d5bd7;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.icon_modal {
  width: 30px;
  height: 30px;
  padding: 5px 5px 5px 5px;
  border-radius: 150px;
}

img {
  cursor: context-menu;
}

.body {
  width: 70rem;
  height: 450px !important;
  display: flex;
  height: auto;
  justify-content: center;
}

.body-swip {
  width: 100%;
}

.swiper-button-color {
  color: #b3cfff;
  width: 70px;
  height: 70px;
  background-color: #89abe6;
  border-radius: 20px;
}

.swiper-button-next {
  width: 80px;
  height: 80px;
  margin-right: 7%;
}

.swiper-button-prev {
  width: 80px;
  height: 80px;
  margin-left: 7%;
}

.swiper-button-prev,
.swiper-button-next {
  top: 46%;
}

.ContentProgressBar {
  display: flex;
  justify-content: center;

  .ProgressBar {
    background-color: #89abe6 !important;
    margin-top: 12px;
    width: 70% !important;
    height: 10px;
    border-radius: 20px !important;
  }
}

.progress-bar {
  background-color: #321fdb !important;
}

.progress-bar-striped {
  background-image: none !important;
}

.img_progress {
  width: 70px;
  height: 70px;
  margin: 0 5px 0 5px;
}

.swip_active {
  width: 180px;
}

div.swiper-slide.swiper-slide-active > .swip_active {
  width: 280px;
}

div.swiper-slide.swiper-slide-prev > .swip_active {
  width: 180px;
}

div.swiper-slide.swiper-slide-next > .swip_active {
  width: 180px;
}

.swiper {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;

  .swiper-slide {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    height: auto !important;
    font-weight: bold;
    background-color: transparent;
    background-position: center;
    color: black;
  }

  .card {
    // border-color: rgba(116, 185, 255, 0.7) !important;
    border-color: transparent;
    background-color: transparent;
    // padding: 40px 40px 40px 40px;
    transition: 0.3s;
    border-radius: 50px;
    /* 5px rounded corners */
    cursor: pointer;
  }

  .icon {
    height: 100%;
    width: 100%;
    margin-bottom: 20px;
  }
}

.icon {
  width: 30px;
  height: 30px;
  padding: 5px 5px 5px 5px;
  border-radius: 150px;
}

.modal_text {
  margin-left: 15px;
  font-size: 20px;
  font-weight: 500;
}

.modal_inactive {
  background-color: white;
  height: 40px;
  padding: 5px 10px 5px 10px;
  border-radius: 50px;
  width: 100%;
  display: flex;
  color: #b2bec3;
  cursor: context-menu;
  margin: 5% 0;
}

.modal_active {
  background-color: white;
  cursor: pointer;
  height: 40px;
  padding: 5px 10px 5px 10px;
  border-radius: 50px;
  width: 100%;
  display: flex;
  color: #1d5bd7;
  margin: 5% 0;
}

.icon_active {
  border: 2px solid #1d5bd7;
}

.icon_inactive {
  border: 2px solid #b2bec3;
}

::v-deep .modal-content {
  width: 70%;
  height: auto;
  background-color: #89abe6;
  border-radius: 30px;
}

::v-deep .modal-dialog {
  left: 11%;
  top: 25%;
}

::v-deep .modal-header {
  display: none;
}

::v-deep .modal-footer {
  display: none;
}

// resolution mobile
@media screen and (min-width: 300px) and (max-width: 600px) {
  .display-none {
    display: none;
  }

  ::v-deep .modal-dialog {
    left: 35%;
    top: 25%;
  }

  ::v-deep .modal-content {
    width: 60%;
  }

  .modal_text {
    font-size: 18px;
  }

  .card {
    box-shadow: 0 0 0 0;
  }

  ::v-deep .vm--modal {
    width: 100% !important;
    left: 0 !important;
    height: auto !important;
  }

  .progress_image {
    margin-top: 10%;
  }

  .ProgressBar {
    margin-top: 10% !important;
  }
}

// resolution ipad
@media only screen and (min-width: 767px) and (max-width: 1024px) {
  .display-none {
    display: none;
  }

  .card {
    box-shadow: 0 0 0 0;
  }
}

// resolution ipad pro
@media only screen and (min-width: 1024px) and (max-width: 1365px) {
  .body {
    width: 60rem !important;
  }

  .card {
    box-shadow: 0 0 0 0;
  }
}

@media only screen and (min-width: 1366px) and (max-width: 1399px) {
  .swiper-button-prev,
  .swiper-button-next {
    top: 47%;
  }

  .card {
    box-shadow: 0 0 0 0;
  }
}

@media only screen and (min-width: 1400px) and (max-width: 1500px) {
  .swiper-button-prev,
  .swiper-button-next {
    top: 47%;
  }
}

@media only screen and (min-width: 1600px) {
  .swiper-button-prev,
  .swiper-button-next {
    top: 47%;
  }
}

@media only screen and (min-width: 1700px) and (max-width: 1800px) {
  .swiper-button-prev,
  .swiper-button-next {
    top: 47%;
  }

  .swiper-button-next {
    margin-right: 0;
    position: absolute;
    right: 10%;
  }

  .swiper-button-prev {
    margin-left: 0;
    position: absolute;
    left: 10%;
  }
}

@media only screen and (min-width: 1900px) {
  .swiper-button-prev,
  .swiper-button-next {
    top: 47%;
  }

  .swiper-button-next {
    margin-right: 0;
    position: absolute;
    right: 15%;
  }

  .swiper-button-prev {
    margin-left: 0;
    position: absolute;
    left: 15%;
  }
}
</style>
